import { ISuggestionResponse } from "../types/suggestion-response";

export default function defaultSuggestionResponse(): ISuggestionResponse {
    return {
        articles: [],
        flexibleSets: [],
        contents: [],
        topSearchQueries: [],
        priceMandantSettingsArticles: {
            currencySymbolWeb: "",
            currencySymbolMobile: "",
            prependCurrencySymbolWeb: false,
            prependCurrencySymbolMobile: false
        },
        priceMandantSettingsFlexibleSet: {
            numberDecimalDigits: 0,
            numberGroupSizes: 0,
            numberDecimalSeparator: "",
            numberGroupSeparator: "",
            currencySymbol: "",
            prependCurrencySymbol: false
        }
    };
}
